import Enllac from 'components/3catinfo/Enllac';
import Imatge from 'components/3catinfo/Imatge';
import styles from './destacat.module.scss';
import Icona from 'components/3catinfo/ui/Icona';
import clsx from 'clsx';
import Etiquetes from 'components/3catinfo/Etiquetes';
import Etiqueta from 'components/3catinfo/Etiqueta';
import { is3CatInfoVerificacio } from '@portal-internet/core';
import { useEffect, useState, useRef } from 'react';
import { useSwiper, useSwiperSlide } from 'swiper/react';

const calcularTextAvailableHeight = (textRef, titolRef) => {
    return (
        textRef.current.offsetHeight -
        parseFloat(window.getComputedStyle(textRef.current).paddingTop) -
        titolRef.current.offsetHeight -
        parseFloat(window.getComputedStyle(titolRef.current).marginBottom)
    );
};

const calcularMaxLinies = (availableHeight, entradetaRef) => {
    return parseInt(availableHeight / parseFloat(window.getComputedStyle(entradetaRef.current).lineHeight));
};

const DestacatBasic = (props) => {
    const { item, routePath, testId, estil, tema, priorityImage = false, numColumnsRow = 0, tag = 'h3' } = props;

    const { id, titol, permatitle, entradeta, imatges, tipologia, domini, agrupacions, tags, canals_directes_embedats } =
        item || props;
    const isVerifica = is3CatInfoVerificacio(agrupacions) || is3CatInfoVerificacio(tags);

    const { isActive } = useSwiperSlide();
    const swiper = useSwiper();

    // Evita la navegació si el slide no és actiu i avança al següent
    const handleClick = (event) => {
        if (isActive) {
            return true; // Permet la navegació si el slide és actiu
        } else {
            event.preventDefault();
            event.stopPropagation();
            swiper.slideNext(); // Avança al següent slide
            return false;
        }
    };

    let TagSeo = tag;

    const { redlAuxState = {} } = item || props;
    const { isRedlId, isRedlTipologia } = redlAuxState;
    const [hasRedlParams, setHasRedlParams] = useState(false);
    const [isDesplegat, setIsDesplegat] = useState(false);
    const [isDesplegatHeight, setIsDesplegatHeight] = useState(0);
    const route = { slug: permatitle || titol, id, tipologia, type: routePath, domini };
    const textRef = useRef();
    const titolRef = useRef();
    const entradetaRef = useRef();
    const floatRef = useRef();

    useEffect(() => {
        if (isRedlId || isRedlTipologia) {
            setHasRedlParams(true);
        }
    }, [isRedlId, isRedlTipologia]);

    useEffect(() => {
        function calculaText() {
            textRef.current.style.overflow = 'hidden';
            // Comprobem si el contingut cap a dins el contenidor. Si no hi cap, executem el codi per mostrar el "més"
            if (textRef.current != null) {
                if (textRef.current.scrollHeight > textRef.current.offsetHeight) {
                    setIsDesplegatHeight(textRef.current.scrollHeight);

                    const availableHeight = calcularTextAvailableHeight(textRef, titolRef);
                    const maxLinies = calcularMaxLinies(availableHeight, entradetaRef);

                    //Posem un line-clamp a l'entradeta per garantir que no es veu cap línia parcialment tallada
                    entradetaRef.current.style.WebkitLineClamp = maxLinies;
                    textRef.current.style.overflow = 'visible';
                    floatRef.current.style.height =
                        availableHeight - parseFloat(window.getComputedStyle(entradetaRef.current).lineHeight) * 2 + 'px';
                } else {
                    setIsDesplegatHeight(0);
                }
            }
        }

        document.fonts.ready.then(function () {
            calculaText();
        });

        let resizeTimeOut;
        const handleResize = () => {
            clearTimeout(resizeTimeOut);
            resizeTimeOut = setTimeout(() => {
                if (entradetaRef.current != null) {
                    entradetaRef.current.style.WebkitLineClamp = 'unset';
                    setIsDesplegatHeight(0);
                    calculaText();
                }
            }, 500);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleDesplega = () => {
        if (isDesplegat) {
            setIsDesplegat(false);
            textRef.current.style.marginTop = 0 + 'px';
        } else {
            setIsDesplegat(true);
            textRef.current.style.marginTop = (isDesplegatHeight - textRef.current.offsetHeight + 22) * -1 + 'px';
        }
    };
    const styleCos = clsx(styles.cos, styles.hasRedlParams && hasRedlParams);
    const styleWrapper = clsx(styles.imatgeWrapper, tema && styles[tema]);
    const stylesDestacat = clsx(
        styles.destacatBasic,
        isDesplegat && styles.desplegat,
        isDesplegatHeight > 0 && styles.desplegable,
        estil && styles[estil],
        numColumnsRow > 0 && styles['col' + numColumnsRow]
    );

    if (!titol) {
        return <></>;
    }

    return (
        <div key={`destacat-basic-${id}`} className={stylesDestacat} {...(testId && { 'data-testid': testId })}>
            <section className={styleCos}>
                {imatges && (
                    <div className={styleWrapper} data-testid='destacat-content-imatge'>
                        <Imatge
                            imatges={imatges}
                            className={styles.imatge}
                            tipus='web_destacat'
                            numColumnsRow={numColumnsRow}
                            aria-hidden='true'
                            layout='fill'
                            loading='lazy'
                            objectFit='cover'
                            priority={priorityImage}
                            crop='1903'
                            data_testid='destacat-img'
                        />
                        <div className={styles.labelWrapper} data-testid='etiqueta'>
                            {canals_directes_embedats ? (
                                <Etiqueta
                                    className={styles.labelDirecte}
                                    text='En directe'
                                    icona='directes'
                                    isBlanc={true}
                                    tipus='highlight'
                                />
                            ) : (
                                <Etiquetes agrupacions={agrupacions} id={id} />
                            )}
                        </div>
                    </div>
                )}
                <div className={styles.textWrapper} ref={textRef}>
                    {isVerifica && <div className={styles.avantitol}>3catinfo verifica</div>}
                    <TagSeo
                        className={styles.titol}
                        data-testid='destacat-titol'
                        ref={titolRef}
                        dangerouslySetInnerHTML={{ __html: titol }}
                    ></TagSeo>
                    <div className={styles.entradetaWrapper}>
                        <div className={styles.entradeta} ref={entradetaRef}>
                            <div className={styles.float_entradeta} ref={floatRef}></div>
                            <div dangerouslySetInnerHTML={{ __html: entradeta }}></div>
                            <div className={styles.mes}>
                                {!isDesplegat ? (
                                    <>
                                        ...{' '}
                                        <button onClick={handleDesplega}>
                                            Més{' '}
                                            <Icona
                                                icona='fletxa_simple_avall'
                                                className={styles.ico_mes}
                                                inline={true}
                                                isBlanc={true}
                                            />
                                        </button>
                                    </>
                                ) : (
                                    <button onClick={handleDesplega}>
                                        Menys{' '}
                                        <Icona
                                            icona='fletxa_simple_amunt'
                                            className={styles.ico_mes}
                                            inline={true}
                                            isBlanc={true}
                                        />
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <Enllac route={route} className={styles.llegeix} onClick={handleClick}>
                    <span className='sr-only'>Llegeix la notícia</span>
                </Enllac>
            </section>
        </div>
    );
};

export default DestacatBasic;
